export default __webpack_public_path__ + "static/media/water9.4acbc112.png";